import {
  ProjectHeaderButton,
  StyledIcon,
} from "@/containers/Project/components/ProjectHeader/styled";
import { useExternalLinksQuery } from "@/services";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faChartLine } from "@fortawesome/free-solid-svg-icons";
import { Row } from "antd";
import { useIntl } from "react-intl";

interface IProps {
  projectNumber: string;
}

export const CTQButton = ({ projectNumber }: IProps) => {
  const intl = useIntl();

  const { data: externalLinks } = useExternalLinksQuery({});

  const openProjectInCTQ = (): void => {
    window.open(`${externalLinks?.ctqUrl}projects/${projectNumber}`);
  };

  return (
    <ProjectHeaderButton
      type="text"
      data-test-id="view-project-button"
      onClick={(): void => openProjectInCTQ()}
    >
      <Row justify="center">
        <StyledIcon icon={faChartLine as IconProp} height="20px" />
      </Row>
      <Row justify="center">
        {intl.formatMessage({ id: "project.viewCTQProjectLabel" })}
      </Row>
    </ProjectHeaderButton>
  );
};
